export const GET_APP_AGENT_ROLE_MENU = 'GET_APP_AGENT_ROLE_MENU';
export const UPDATE_SEARCH_PARAMS_INFO = 'UPDATE_SEARCH_PARAMS_INFO';
export const GET_AGENT_ROLES = 'GET_AGENT_ROLES';
export const SAVE_APP_AGENT_ROLE_MENU = 'SAVE_APP_AGENT_ROLE_MENU';
export const FIND_AGENTS_CDP_ROLE_PAGING_LIST = 'FIND_AGENTS_CDP_ROLE_PAGING_LIST';
export const CLEAR_AGENT_ROLES_MENU_ALL = 'CLEAR_AGENT_ROLES_MENU_ALL';
export const ROLE_AGENT_EXCEL_DOWNLOAD = 'ROLE_AGENT_EXCEL_DOWNLOAD';
export const GET_AGENTS_TAKEN_ROLE = 'GET_AGENTS_TAKEN_ROLE';
export const GET_HQ_LIST_BY_CHANNEL = 'GET_HQ_LIST_BY_CHANNEL';
export const GET_AGENCY_LIST_BY_HQ = 'GET_AGENCY_LIST_BY_HQ';

export const GET_HQ_LIST_BY_CHANNEL_SUCCESS = 'GET_HQ_LIST_BY_CHANNEL_SUCCESS';
export const GET_AGENCY_LIST_BY_HQ_SUCCESS = 'GET_AGENCY_LIST_BY_HQ_SUCCESS';

export const GET_HQ_AGENCY_CLEAR = 'GET_HQ_AGENCY_CLEAR';

//사용자(설계자별) 메뉴목록 조회
export const getAppAgentRoleMenu = payload => {
    
    return { type: GET_APP_AGENT_ROLE_MENU, payload };
};

//검색조건
export const updateSearchParamsInfo = payload => {
    return { type: UPDATE_SEARCH_PARAMS_INFO, payload };
};

export const getAgentRoles = payload => {
    return { type: GET_AGENT_ROLES, payload };
};

export const saveAppAgentRoleMenu = payload => {
    return { type: SAVE_APP_AGENT_ROLE_MENU, payload };
};

export const findAgentsCdpRolePagingList = payload => {
    
    return { type: FIND_AGENTS_CDP_ROLE_PAGING_LIST, payload };
};

export const roleAgentExcelDownload = payload => {
    
    return { type: ROLE_AGENT_EXCEL_DOWNLOAD, payload };
};

export const getAgentsTakenRole = payload => {
    return { type: GET_AGENTS_TAKEN_ROLE, payload };
}

export const getHqListByChannel = data => {
    return { type: GET_HQ_LIST_BY_CHANNEL, payload: data };
  };
  
  export const getAgencyListByHq = data => {
    return { type: GET_AGENCY_LIST_BY_HQ, payload: data };
  };
  
  export const getHqAgencyClear = data => {
    return { type: GET_HQ_AGENCY_CLEAR, payload: data };
  };
  

